import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { omit } from 'lodash-es';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { PopoverItem } from 'site-modules/shared/components/popover-item/popover-item';

import './mic-button.scss';

const MIC_ICON = getStaticImageUrl('/img/chat-canvas/icon-mic.svg');

export function MicButton({ isListening = false, isDisabled = false, onClick = null }) {
  const tooltipText = isListening ? 'Stop recording' : 'Use microphone';

  return (
    <PopoverItem
      screenReaderTooltipLabel={tooltipText}
      placement="bottom"
      className="d-flex pos-r"
      innerClassName="text-nowrap px-0_75 py-0_5 text-cool-gray-30"
      boundariesElement="clippingParents"
      trigger="hover"
      delay={{ show: 0, hide: 0 }}
      fade={false}
      renderTarget={(targetProps, tooltipRef) => (
        <Button
          {...omit(targetProps, ['onKeyDown'])}
          aria-label={tooltipText}
          innerRef={tooltipRef}
          color="link"
          onClick={onClick}
          className="mic-button pos-r text-transform-none text-decoration-none px-0 py-0"
          data-tracking-id="chat_canvas_tool"
          disabled={isDisabled}
        >
          <img className="pos-a center-xy" width={28} src={MIC_ICON} alt="" />
        </Button>
      )}
    >
      {tooltipText}
    </PopoverItem>
  );
}

MicButton.propTypes = {
  isListening: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
};
